import { createContext } from 'react'
import type { WrappedStoryDispatchAction } from './wrappedStoryStateReducer'
import noop from 'lib/function/noop'

const WrappedStoryDispatchContext = createContext<React.Dispatch<WrappedStoryDispatchAction>>(noop)

export default WrappedStoryDispatchContext
